/**
 *
 *  Copyright 2007-2012 redfish.to unless stateted elsewhere
 *
 *  Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 *  file except in compliance with the License. You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under the
 *  License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 *  either express or implied. See the License for the specific language governing permissions
 *  and limitations under the License.
 **/

import $ from 'jquery';
window.$ = $;
window.jQuery = $;
//-------------------- redfish.js

export function gendered_caption(caption, gender) {
    var gc={}
    gc['klient']={}
    gc['klient']['m']="Klient";
    gc['klient']['w']="Klientin";

    gc['klientenakt_c']={}
    gc['klientenakt_c']['m']="Klientenakt";
    gc['klientenakt_c']['w']="Klientinnenakt";

    gc['klientenakt_r']={}
    gc['klientenakt_r']['m']="Angehörigenakt";
    gc['klientenakt_r']['w']="Angehörigenakt";

    gc['klientenakt_v']={}
    gc['klientenakt_v']['m']="Besucherakt";
    gc['klientenakt_v']['w']="Besucherinnenakt";

    gc['klientenakt_cr']={}
    gc['klientenakt_cr']['m']="Klienten- & Angehörigen-Akt";
    gc['klientenakt_cr']['w']="Klientinnen- & Angehörigen-Akt";

    gc['klientenakt_cv']={}
    gc['klientenakt_cv']['m']="Klienten- & Besucher-Akt";
    gc['klientenakt_cv']['w']="Klientinnen- & Besucherinnen-Akt";

    gc['klientenakt_rv']={}
    gc['klientenakt_rv']['m']="Besucher- & Angehörigen-Akt";
    gc['klientenakt_rv']['w']="Besucherinnen- & Angehörigen-Akt";

    gc['mitarbeiter']={}
    gc['mitarbeiter']['m']="Mitarbeiter";
    gc['mitarbeiter']['w']="Mitarbeiterin";

    gc['mitarbeiterakt']={}
    gc['mitarbeiterakt']['m']="Mitarbeiterakt";
    gc['mitarbeiterakt']['w']="Mitarbeiterinnenakt";

    gc['personenakt']={}
    gc['personenakt']['m']="Personenakt";
    gc['personenakt']['w']="Personenakt";

    gc['angehöriger']={}
    gc['angehöriger']['m']="Angehöriger";
    gc['angehöriger']['w']="Angehörige";
    r=gc[caption][gender];
    return r
}


//------------ { Kienten und Mitarbeiterakt --------------

export function set_gendered_person_info(p) {
    set_person_avatar(p);
    set_h1_caption(p);
}


export function set_person_avatar(p) {
    if ($('#'+p+'_geschlecht').val() == "w") {
        gender_url = "female_user"
    } else {
        gender_url = "male_user"
    }
    if ($('#'+p+'_subtype').prop('checked')) {
        relative_url = "_relative"
    } else {
        relative_url = ""
    }
    if ($('#'+p+'_avatar')) {
        $('#'+p+'_avatar').attr('class', 'icon_' + gender_url + relative_url + '_128')
    }
}


export function set_h1_caption(p) {
    switch(p) {
        case 'client':
            caption_key="klientenakt_"+$('#client_roles').val();
            break;
        case 'employee':
            caption_key="mitarbeiterakt";
            break;
        default:
            caption_key='personenakt'
    }
    $('#h1_'+p+'_caption').html(gendered_caption(caption_key, $('#'+p+'_geschlecht').val()));
}


export function bind_gender_watch(p) {
    $('#'+p+'_geschlecht').bind('change', function(){set_gendered_person_info(p)});
    set_gendered_person_info(p);
}


const AVATAR_STYLE_DEFAULT = 'soft_radial';

const PALETTE_PINK_GREEN = [
    '#6a9fd0', '#7aa8d6', '#8ab1dc', '#9ab9e2', '#a9c2e7', '#b9cbea', '#c8d4ee', '#d8ddee', '#e2e7eb', '#d0e2d4',
    '#beddbe', '#aac7a8', '#98b093', '#86a97d', '#75a268', '#83a26a', '#92a26b', '#a1a26d', '#b0a16e', '#bfa06f',
    '#d09f70', '#db9376', '#e5877b', '#ee7b81', '#f76f86', '#fa6b92', '#fd68a0', '#f967ae', '#f466bb', '#ef64c9',
    '#d664d2', '#ba64d6', '#9e63da', '#8263de', '#7263c3', '#6463a7'
];

const PALETTE_RAINBOW = [
    '#4a90e2', '#5ba0eb', '#6bb0f3', '#7bc1fc', '#89cdfb', '#97d8fb', '#a6e4fc', '#b5effd', '#c3f6f5', '#b2f3e4',
    '#a1f1d3', '#8feec1', '#7eeca9', '#6dea91', '#5ce978', '#71e564', '#86e14f', '#9bdc3b', '#b0d727', '#c4d20d',
    '#d8ca08', '#e8bc0b', '#f7ad0d', '#f89d1a', '#fa8e27', '#fc7f34', '#fd6e41', '#fb5a5d', '#f74779', '#f23395',
    '#ed1eb2', '#d91ac8', '#c316dd', '#ac12f2', '#9b0de3', '#8b08d3'
];

// Dusty A–Z wheel: low saturation, high lightness, easier on the eyes than rainbow.
const PALETTE_SOFT = [
    '#c9b4b4', '#c9b8ac', '#c9bca4', '#c4c09c', '#bcc49c', '#b4c4a4',
    '#acc4ac', '#a4c4b4', '#9cc4bc', '#9cc0c4', '#9cb8c4', '#9cb0c4',
    '#9ca8c4', '#a4a0c4', '#ac9cc4', '#b49cc0', '#bc9cb8', '#c49cb0',
    '#c4a0a8', '#c4a4a0', '#c4a898', '#c4b090', '#c0b48c', '#b8b890',
    '#b0bc98', '#a8c0a0'
];

function avatar_palette_for_style(style) {
    if (style === 'rainbow_radial' || style === 'rainbow_uni') return PALETTE_RAINBOW;
    if (style === 'soft_radial' || style === 'soft_uni') return PALETTE_SOFT;
    return PALETTE_PINK_GREEN;
}

function avatar_letter_index(ch, palette_length) {
    const code = (ch || 'A').toString().toUpperCase().charCodeAt(0);
    if (code < 65 || code > 90 || palette_length <= 1) return 0;
    return Math.round((code - 65) * (palette_length - 1) / 25);
}

// A–Z gray: clients 30%–80% black; employees 20%–50% black (nachname outer, vorname inner on radial).
function avatar_gray_for_char(ch, kind) {
    const t = avatar_letter_index(ch, 26) / 25;
    const black_min = kind === 'employee' ? 0.20 : 0.30;
    const black_max = kind === 'employee' ? 0.50 : 0.80;
    const black = black_min + t * (black_max - black_min);
    const value = Math.round((1 - black) * 255);
    let hex = value.toString(16);
    if (hex.length < 2) hex = '0' + hex;
    return '#' + hex + hex + hex;
}

function avatar_color_for_char(ch, palette, style, kind) {
    if (style === 'gray_radial' || style === 'gray_uni') return avatar_gray_for_char(ch, kind);
    if (style === 'pink_green_radial') {
        return palette[(ch.charCodeAt(0) || 0) % palette.length];
    }
    return palette[avatar_letter_index(ch, palette.length)];
}

function resolve_avatar_style(avatarElement, style) {
    if (style) return style;
    if (avatarElement && avatarElement.getAttribute) {
        const from_data = avatarElement.getAttribute('data-avatar-style');
        if (from_data) return from_data;
    }
    return AVATAR_STYLE_DEFAULT;
}

function resolve_avatar_kind(avatarElement, kind) {
    if (kind) return kind;
    if (avatarElement && avatarElement.getAttribute) {
        return avatarElement.getAttribute('data-avatar-kind') || 'client';
    }
    return 'client';
}

function hex_to_rgb_channels(hex) {
    const raw = (hex || '').toString().replace('#', '');
    if (raw.length === 3) {
        return {
            r: parseInt(raw.charAt(0) + raw.charAt(0), 16),
            g: parseInt(raw.charAt(1) + raw.charAt(1), 16),
            b: parseInt(raw.charAt(2) + raw.charAt(2), 16)
        };
    }
    return {
        r: parseInt(raw.slice(0, 2), 16) || 0,
        g: parseInt(raw.slice(2, 4), 16) || 0,
        b: parseInt(raw.slice(4, 6), 16) || 0
    };
}

function rgb_to_hsl(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h = 0;
    let s = 0;
    if (max !== min) {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
        else if (max === g) h = (b - r) / d + 2;
        else h = (r - g) / d + 4;
        h /= 6;
    }
    return { h, s, l };
}

function hue_to_rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}

function hsl_to_hex(h, s, l) {
    let r;
    let g;
    let b;
    if (s === 0) {
        r = g = b = l;
    } else {
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hue_to_rgb(p, q, h + 1 / 3);
        g = hue_to_rgb(p, q, h);
        b = hue_to_rgb(p, q, h - 1 / 3);
    }
    const to_hex = (channel) => {
        let hex = Math.round(channel * 255).toString(16);
        if (hex.length < 2) hex = '0' + hex;
        return hex;
    };
    return '#' + to_hex(r) + to_hex(g) + to_hex(b);
}

function avatar_color_at_lightness(hex, lightness) {
    const rgb = hex_to_rgb_channels(hex);
    const hsl = rgb_to_hsl(rgb.r, rgb.g, rgb.b);
    return hsl_to_hex(hsl.h, hsl.s, lightness);
}

function apply_avatar_circle_fill(avatarElement, name, surname, initials, style, kind) {
    const resolved = resolve_avatar_style(avatarElement, style);
    const palette = avatar_palette_for_style(resolved);
    const uni = resolved.indexOf('uni') !== -1;
    const resolved_kind = resolve_avatar_kind(avatarElement, kind);
    avatarElement.textContent = initials || '?';
    if (resolved_kind === 'employee') {
        avatarElement.style.color = '#666';
        const nachname_color = avatar_color_for_char(name, palette, resolved, resolved_kind);
        const vorname_color = uni
            ? nachname_color
            : avatar_color_for_char(surname, palette, resolved, resolved_kind);
        // CSS 0% is the center (inside). Outside→inside: Nachname → Vorname at 30% → white.
        avatarElement.style.background =
            `radial-gradient(circle closest-side, #ffffff 0%, ${vorname_color} 70%, ${nachname_color} 100%)`;
        return;
    }
    avatarElement.style.color = '';
    if (uni) {
        avatarElement.style.background = avatar_color_for_char(name, palette, resolved, resolved_kind);
    } else {
        const nameColor = avatar_color_for_char(name, palette, resolved, resolved_kind);
        const surnameColor = avatar_color_for_char(surname, palette, resolved, resolved_kind);
        avatarElement.style.background = `radial-gradient(circle, ${surnameColor} 20%, ${nameColor} 60%)`;
    }
}

export function applyAvatarPhoto(avatarElement, url) {
    if (!avatarElement || !url) return;
    avatarElement.classList.add('is-photo');
    avatarElement.style.backgroundImage = `url("${url}")`;
    avatarElement.style.backgroundSize = '100% 100%';
    avatarElement.style.backgroundPosition = 'center';
    avatarElement.style.backgroundRepeat = 'no-repeat';
    avatarElement.style.backgroundColor = '#fff';
    avatarElement.style.color = 'transparent';
    avatarElement.textContent = '';
    avatarElement.setAttribute('data-avatar-url', url);
}

export function clearAvatarPhoto(avatarElement) {
    if (!avatarElement) return;
    avatarElement.classList.remove('is-photo');
    avatarElement.style.backgroundImage = '';
    avatarElement.removeAttribute('data-avatar-url');
}

export function generateAvatarCircleFill(name, surname, selector = '.avatar_circle', style, kind) {
    name = name || '';
    surname = surname || '';
    const initials = `${name.charAt(0)}${surname.charAt(0)}`.toUpperCase();
    const elements = [];
    if (selector && selector.nodeType === 1) {
        elements.push(selector);
    } else if (typeof selector === 'string') {
        document.querySelectorAll(selector).forEach((el) => elements.push(el));
    }
    elements.forEach((avatarElement) => {
        if (avatarElement.classList && avatarElement.classList.contains('is-photo') && avatarElement.getAttribute('data-avatar-url')) {
            applyAvatarPhoto(avatarElement, avatarElement.getAttribute('data-avatar-url'));
            return;
        }
        apply_avatar_circle_fill(avatarElement, name, surname, initials, style, kind);
    });
}
//generateAvatar('John', 'Smith');


export function paint_tr(id) {
    //$('.record_list').stickyTableHeaders({fixedOffset: 52});
    // renders record_list tables alternating table-row color
    // u:240227
    // $(".thisclass:not(.line_ruler)")
    var not_class=':not(.line_ruler)';
    if (id) {
        var table_selector='#'+id+' ';
    } else {
        var table_selector='.record_list ';
    }
    //console.log(table_selector);
    // 260818nrai: one space-separated string — extra args are treated as duration/easing by jquery-ui effects
    $(table_selector+'tr'+not_class).removeClass('rowcolor0 rowcolor1 rowcolor2 rowcolor3');

    $(table_selector+'tr:even'+not_class).addClass('rowcolor0');
    $(table_selector+'tr:odd'+not_class).addClass('rowcolor1');
    $(table_selector+'tr.deleted:even'+not_class).addClass('rowcolor2');
    $(table_selector+'tr.deleted:odd'+not_class).addClass('rowcolor3');
}

export function highlightElement(options={}) {
    // c:240901 nr,gw
    // Set defaults for options if not provided
    const scroll_to_id = options.scroll_to_id || null;
    const highlight_id = options.highlight_id || 'body';
    const highlight_color = options.highlight_color || '#fffcb4';
    const scrolltop_duration = options.fadein_speed || 500;
    const fadein_duration = options.fadein_speed || 500;
    const fadeout_duration = options.fadein_speed || 2000;
    const pause_duration = options.pause_duration || 1000;

    if (scroll_to_id !== null) {
        // Scroll to Container
        $('html, body').animate({
            scrollTop: $(scroll_to_id).offset().top
        }, scrolltop_duration);
    }

    // Fade orange background in and out
    $(highlight_id).css('background', highlight_color).animate(
        { backgroundColor: highlight_color }, // Animate to a solid color
        fadein_duration, // Duration of the fade-in (1 second)
        function() {
            // Callback after fade-in completes
            setTimeout(function() {
                $(highlight_id).animate(
                    { backgroundColor: 'transparent' }, // Animate back to transparent
                    fadeout_duration // Duration of the fade-out (1 second)
                );
            }, pause_duration); // Pause for 1 second before fading out
        }
    );
}


export function popup_window(url, windowname, w, h, x, y) {
    window.open(url, windowname, "resizable=no, toolbar=no, scrollbars=no, menubar=no, status=no, directories=no, width=" + w + ", height=" + h + ", left=" + x + ", top=" + y);
}

//--------------- html5sortable.js -------------------------------
// based on https://github.com/lukasoppermann/html5sortable

export function sortable_ready(){
    sortable('.sortable', {
        placeholderClass: "sortable-placeholder",
        cursor: 'hand',
        handle: '.sortable_handle',
        forcePlaceholderSize: true,
        opacity: 0.5,
        scroll: true});


    sortable('.sortable')[0].addEventListener('sortupdate', function(e) {

        console.log(e.detail);

        // array to store new order
        updated_order = []

        // populate the updated_order array with the new task positions
        $('.sortable tr').each(function(i){
            updated_order.push({ id: $(this).data("id"), position: i+1 });
        });

        // send the updated order via ajax
        $.ajax({
            type: "post",
            url: '/categories/resort',
            data: { order: updated_order }
        });
    });
}


export function auto_correct_two_digit_year_in_date(date_field, mode, the_button) {
    // correct two digit year of future dates to 19xx
    // after 68 is treated  - by moment.js(?) - as 1968, before (eg 66 as 2066)
    // c: 210201 ca.
    // u: 210503

    if ($(date_field).val()) {
        var the_date_validation = moment_date_validation(date_field, 'Datum ist ungültig. ', the_button);

        if (the_date_validation) {
            var the_date = moment($(date_field).val(), "DD.MM.YYYY");

            //console.log('auto_correct_two_digit_year() - the_date.year():'+the_date.year());
            //console.log("auto_correct_two_digit_year() - the_date.diff(moment(),'years'):"+the_date.diff(moment(),'years'));

            var corrected_year = the_date.year();
            if (corrected_year >= 1 && corrected_year <= 9) {
                // if 1 to 9 is set as year, Year returns 0001, so add 2000
                // from 10 up, 2010 and higher is returned by moment.js
                corrected_year = 2000 + corrected_year
                the_date.set({year: corrected_year});
            } else if (corrected_year < 1900) {
                // prevent historical dates prior to 1900
                // in case of incidentally entered "historical" date: 1712 -> 2012
                // REFACTOR! Add option to explicitly allow them
                corrected_year = 2000 + corrected_year % 100;
                the_date.set({year: corrected_year});
            } else if (corrected_year / 1000 > 2) {
                // prevent science fiction dates: 3066 -> 2066, 7450 -> 2050
                // REFACTOR! Add option to explicitly allow them
                var corrected_year = 2000 + corrected_year % 100;
            }

            if (mode == 'birthday' && the_date.diff(moment()) > 0) {
                var corrected_year = 1900 + (corrected_year - 2000);
            }

            if (~mode.indexOf("past_1y") && the_date.diff(moment(), 'years') < -1 ||
                ~mode.indexOf("past_2y") && the_date.diff(moment(), 'years') < -2 ||
                ~mode.indexOf("past_5y") && the_date.diff(moment(), 'years') < -5 ||
                ~mode.indexOf("past_10y") && the_date.diff(moment(), 'years') < -10 ||
                ~mode.indexOf("past_20y") && the_date.diff(moment(), 'years') < -20) {
                if (corrected_year < 2000) {
                    // if a year lower than 2000, add last 2 digits to 2000
                    var corrected_year = 2000 + corrected_year % 100;
                } else {
                    // if date is a 2000er, revert to current year
                    var corrected_year = moment().year;
                }
            }

            if (~mode.indexOf("future_1y") && the_date.diff(moment(), 'years') > 1 ||
                ~mode.indexOf("future_2y") && the_date.diff(moment(), 'years') > 2 ||
                ~mode.indexOf("future_5y") && the_date.diff(moment(), 'years') > 5 ||
                ~mode.indexOf("future_10y") && the_date.diff(moment(), 'years') > 10 ||
                ~mode.indexOf("future_20y") && the_date.diff(moment(), 'years') > 20) {
                // revert to current year
                var corrected_year = moment().year;
            }

            if (~mode.indexOf("future_none") && the_date.diff(moment()) > 0) {
                // no future dates allowed, revert to current date
                the_date = moment();
                var corrected_year = the_date.year();
            }

            if (mode == 'as_is') {
                // keep date as is
            }

            $(date_field).val(moment().set({
                date: the_date.date(),
                month: (the_date.month()),
                year: corrected_year
            }).format("DD.MM.YYYY"));
        }
    }
}


export function auto_correct_two_digit_year_in_birthdate(date_field, the_button) {
    // correct two digit year of future dates to 19xx
    auto_correct_two_digit_year_in_date(date_field, 'birthday', the_button)
}

// Hilfsfunktion: egal ob String, Array von Selektoren, NodeList, jQuery-Objekt...
export function normalizeButtons(submit_buttons) {
    var $set = $();
    //console.log("normalizeButtons input:", submit_buttons);

    if (!submit_buttons) return $set;

    if (typeof submit_buttons === 'string') {
        //console.log("normalizeButtons: treating as selector string");
        return $(submit_buttons);
    }

    if (submit_buttons.jquery) {
        //console.log("normalizeButtons: received jQuery object, length:", submit_buttons.length);
        return submit_buttons;
    }

    if (Array.isArray(submit_buttons)) {
        //console.log("normalizeButtons: treating as array of selectors/elements:", submit_buttons);
        submit_buttons.forEach(function(item) {
            if (!item) return;
            if (typeof item === 'string') {
                //console.log("  -> adding selector:", item, "found", $(item).length, "elements");
                $set = $set.add($(item));
            } else {
                //console.log("  -> adding DOM/jQuery element", item);
                $set = $set.add($(item));
            }
        });
        return $set;
    }

    //console.log("normalizeButtons: fallback case (NodeList or Element)");
    return $(submit_buttons);
}

export function disableUiButtons(submit_buttons) {
    var $buttons = normalizeButtons(submit_buttons);
    //console.log("disableUiButtons: total buttons found:", $buttons.length);

    $buttons.each(function() {
        var $btn = $(this);
        //console.log("Disabling button:", $btn.attr('id'), "tag:", this.tagName, "classes:", $btn.attr('class'));

        $btn.addClass("disabled");
        //console.log("  -> added .disabled, classes now:", $btn.attr('class'));

        if ($btn.is('button, input, select, textarea')) {
            $btn.prop("disabled", true);
            //console.log("  -> .prop('disabled', true) applied");
        } else {
            var el = this;
            var onclickValue = el.getAttribute('onclick');
            //console.log("  -> original onclick:", onclickValue);

            if (onclickValue) {
                el.setAttribute('data-original-onclick', onclickValue);
                el.removeAttribute('onclick');
                //console.log("  -> onclick removed, data-original-onclick set");
            }

            $btn.css("pointer-events", "none")
                .attr("aria-disabled", "true");
            //console.log("  -> pointer-events:none, aria-disabled:true");
        }
    });
}

export function enableUiButtons(submit_buttons) {
    var $buttons = normalizeButtons(submit_buttons);
    //console.log("enableUiButtons: total buttons found:", $buttons.length);

    $buttons.each(function() {
        var $btn = $(this);
        //console.log("Enabling button:", $btn.attr('id'), "tag:", this.tagName, "classes:", $btn.attr('class'));

        $btn.removeClass("disabled");
        //console.log("  -> removed .disabled, classes now:", $btn.attr('class'));

        if ($btn.is('button, input, select, textarea')) {
            $btn.prop("disabled", false);
            //console.log("  -> .prop('disabled', false) applied");
        } else {
            var el = this;
            var originalOnclick = el.getAttribute('data-original-onclick');
            //console.log("  -> restoring onclick:", originalOnclick);

            if (originalOnclick) {
                el.setAttribute('onclick', originalOnclick);
                el.removeAttribute('data-original-onclick');
                //console.log("  -> onclick restored");
            }

            $btn.css("pointer-events", "")
                .removeAttr("aria-disabled");
            //console.log("  -> pointer-events reenabled, aria-disabled removed");
        }
    });
}

export function is_true(val) {
    if (val === true) return true;
    if (val === false) return false;

    if (val == null) return false;

    // normalize to string
    const s = String(val).trim().toLowerCase();

    return (
        s === "1" ||
        s === "true" ||
        s === "yes" ||
        s === "on"
    );
}



export function filename_to_title(n) {
    // returns a well formatted String from a given filename for a document title
    n=n.replace('C:\\fakepath\\', '');
    n=n.replace(/\.[^/.]+$/, ""); // remove file extension
    n=n.replace(/\-/g, ' ');
    n=n.replace(/\_/g, ' ');
    n=n.replace(/\./g, ' ');
    n=n.replace(/\//g, ' ');
    n=n.replace(/\:/g, ' ');
    n=n.replace(/\\/g, ' ');
    n=n.charAt(0).toUpperCase() + n.slice(1); // capitalize first letter of String
    n=n.replace(/([a-z])([A-Z])/g, '$1 $2');  // This will find each occurance of a lower case character followed by an upper case character, and insert a space between them
    n=n.replace(/([a-z])([0-9])/g, '$1 $2');
    n=n.replace(/([A-Z])([0-9])/g, '$1 $2');
    n=n.replace(/([0-9])([a-z])/g, '$1 $2');
    n=n.replace(/([0-9])([A-Z])/g, '$1 $2');
    n=n.replace(/ +(?= )/g,''); // replace multiple spaces by one space
    return n;
}


export function compound_id(params, key) {

//   def self.compound_id(params, key=nil)
//      # compound_ids 'i_27__e_676' bzw. 'i_27__c_17346'
//       # also handle arrays. used in TimerecordsController.get_and_set_current_client()
//       # split by '__'
//       # each split by '_' > first element is key, second value
//       # return hash with key, value pairs {i: 27, e: 676}
    var res=[];
    var is_compound=false;

    if (!Array.isArray(params)) {
        params=[params];
    }
    //console.log(params);
    params.forEach(function(param) {
        var res_param={};
        if (param && param.includes("__")) {
            is_compound=true;
            var id_sets=param.split("__");
            // console.log(id_sets);
            id_sets.forEach(function(id_set) {
                var ids=id_set.split("_");
                //console.log(ids);
                res_param[ids[0]]=Number(ids[1]);
            });

        } else {
            // not compound
            res_param=param;
        }
        res.push(res_param);

    });
    //console.log(res);
    if (is_compound==true && !(key === undefined)) {
        var res_for_key=[];
        res.forEach( function (r) {
            res_for_key.push(r[key]);
        });
        res=res_for_key;
    }
    if (res.length==1) {
        res=res[0];
    }
    //console.log(res);
    return res;

}
//------------ Kienten und Mitarbeiterakt } --------------

export function compressArray(original) {
    // https://gist.github.com/raecoo/4230308
    var compressed = [];
    // make a copy of the input array
    var copy = original.slice(0);

    // first loop goes over every element
    for (var i = 0; i < original.length; i++) {

        var myCount = 0;
        // loop over every element in the copy and see if it's the same
        for (var w = 0; w < copy.length; w++) {
            if (original[i] == copy[w]) {
                // increase amount of times duplicate is found
                myCount++;
                // sets item to undefined
                delete copy[w];
            }
        }

        if (myCount > 0) {
            var a = new Object();
            a.value = original[i];
            a.count = myCount;
            compressed.push(a);
        }
    }

    return compressed;
}

// ----------------------  JQuery RegEx selector ------------------------------------------
// https://j11y.io/snippets/regex-selector-for-jquery/
// by James Padolsey
$.expr[':'].regex = function(elem, index, match) {
    var matchParams = match[3].split(','),
        validLabels = /^(data|css):/,
        attr = {
            method: matchParams[0].match(validLabels) ?
                matchParams[0].split(':')[0] : 'attr',
            property: matchParams.shift().replace(validLabels,'')
        },
        regexFlags = 'ig';
    regex = new RegExp(matchParams.join('').replace(/^\s+|\s+$/g,''), regexFlags);
    return regex.test($(elem)[attr.method](attr.property));
}
//// Select all elements with an ID starting a vowel:
//$(':regex(id,^[aeiou])');

//// Select all DIVs with classes that contain numbers:
//$('div:regex(class,[0-9])');

//// Select all SCRIPT tags with a SRC containing jQuery:
//$('script:regex(src,jQuery)');

//// Select all elements with a width between 100 and 300:
//$(':regex(css:width, ^[1-3]\\d{2}px$)');

//// Select all NON block-level DIVs:
//$('div:not(:regex(css:display, ^block$))');

//$('input:regex(id,docus_dokli_f\\w{3,})');


export function set_toggler_icon(toggler_id, visible_element_id, icon_class_for_hidden_element, icon_class_for_visible_element) {
    if ($(visible_element_id).is(":visible")) {
        $(toggler_id).addClass(icon_class_for_visible_element);
        $(toggler_id).removeClass(icon_class_for_hidden_element);
    } else {
        $(toggler_id).removeClass(icon_class_for_visible_element);
        $(toggler_id).addClass(icon_class_for_hidden_element);
    }
}



export function num_form_eval_errors() {
// iterates through all form_eval_error_for_ input fields and sums up the value attribute
// used to calculate overall state for submit button visibility in ajax-based form evaluation.
// applies to time_record form, client_responsibility_form
    var num_errors=0;
    $('[id^=\'form_eval_error_for_\']').each(function() {
        if ($(this).val()) {
            num_errors+=$(this).val();
        }
    });
    return num_errors;
}


// ----------------------  FILTER related ------------------------------------------

export function set_all_filter_handler_icons(filter_group) {
    var filters=[];
    // 260721nrai: r4 merge — task_type_ids + controller-prefix (noruz_time_records etc.)
    filters['time_records']=['client', 'employee', 'institution', 'task', 'contact_status', 'contact_type', 'task_type_ids']
    filters['employments']=['employee', 'institution', 'employment_mode', 'employment_type', 'employment_purpose']
    var list = filters[filter_group];
    var domGroup = filter_group;
    // Journal forms set #time_records_controller (e.g. noruz_time_records); lock ids use that prefix, not 'time_records'
    if (filter_group === 'time_records') {
        var controllerSegment = journal_filter_group();
        if (controllerSegment) {
            domGroup = controllerSegment;
        }
    }
    if (!list) {
        return;
    }
    for (var i = 0; i < list.length; i++) {
        set_filter_handler_icon('#filter_'+domGroup+'_'+list[i]+'_handler', $('#has_'+domGroup+'_'+list[i]+'_filter').val()=='true', $('#form_mode').val()!='edit');
    }

}


export function set_filter_handler(filter_group, filter_name, filter_is_set, visible) {
    // icon AND hidden_value (always string 'true'/'false' — matches comparisons with == 'true' elsewhere)
    set_filter_handler_icon('#filter_'+filter_group+'_'+filter_name+'_handler', filter_is_set, visible);
    $('#has_'+filter_group+'_'+filter_name+'_filter').val(filter_is_set ? 'true' : 'false');
}


export function set_filter_handler_icon(filter_handler_id, filter_is_set, visible) {
    // sets the lock-icon in a filter_control_4  handler-button to either 'locked' or 'unlocked'
    // according if  filter_is_set
    // used in a *.js.erb  Ajax handler ujs template

    //console.log('set_filter_handler_icon',filter_handler_id, filter_is_set);
    var $handler = $(filter_handler_id);
    var $icon = $handler.find('i');

    if (visible) {
        $handler.removeClass('hidden');
        $icon.removeClass('hidden');

        if (filter_is_set) {
            $handler.addClass('options_button_focus button small round').removeClass('button_as_text');
            $icon.removeClass('fa-unlock').addClass('fa-lock');
        } else {
            $handler.removeClass('options_button_focus button small round').addClass('button_as_text');
            $icon.removeClass('fa-lock').addClass('fa-unlock');
        }
    } else {
        $handler.addClass('hidden');
        $icon.addClass('hidden');
    }
}


export function journal_filter_group() {
    return $('#time_records_controller').val() || 'time_records';
}

export function has_journal_filter(filter_name) {
    return has_filter(journal_filter_group(), filter_name);
}

export function journal_filter_hidden_selector(filter_name) {
    return '#has_' + journal_filter_group() + '_' + filter_name + '_filter';
}

export function has_filter(filter_group, filter_name) {
    return $('#has_'+filter_group+'_'+filter_name+'_filter').val()=='true'
}


export function GetProperty(classOrId,property) {
    // alert( GetProperty(".my_site_title","position") ) ;
    // https://stackoverflow.com/questions/324486/how-do-you-read-css-rule-values-with-javascript
    var FirstChar = classOrId.charAt(0);  var Remaining= classOrId.substring(1);
    var elem = (FirstChar =='#') ?  document.getElementById(Remaining) : document.getElementsByClassName(Remaining)[0];
    return window.getComputedStyle(elem,null).getPropertyValue(property);
}



export function employmentLookupParams() {
    // 260721nrai: r4 merge — work_time_model int from WorkTimeModel select codes + work_time_model_id
    var _wtm_int = (function () {
        var sel = $('#record_work_time_model_id');
        if (!sel.length) return $('#record_work_time_model').val(); // fallback for older partials
        var codes = (sel.data('codes') || {});
        var code = codes[ sel.val() - 0 ] || '';
        return ({ '5tg': 5, 'flex': 1, '7tg': 7 })[code] || '';
    })();
    return {
        year:               $('#record_year').val(),
        von:                $('#record_von').val(),
        bis:                $('#record_bis').val(),
        work_time_model:    _wtm_int,
        work_time_model_id: $('#record_work_time_model_id').val(),
        ts1:                $('#record_ts1').val(),
        ts2:                $('#record_ts2').val(),
        ts3:                $('#record_ts3').val(),
        ts4:                $('#record_ts4').val(),
        ts5:                $('#record_ts5').val(),
        ts6:                $('#record_ts6').val(),
        ts7:                $('#record_ts7').val(),
        wochenstunden:      $('#record_wochenstunden').val(),
        wochenstunden1dp:   $('#record_wochenstunden1dp').val(),
        institution:        $('#record_institution_id').val(),
        employee:           $('#record_employee_id').val(),
        employment_type:    $('#record_employment_type_id').val(),
        employment_mode:    $('#record_employment_mode_id').val(),
        employment_purpose: $('#record_employment_purpose_id').val()
    };
}

export function ajaxLookupEmployments(endpoint) {
    $.post(endpoint, employmentLookupParams())
        .fail(function() {
            console.log(
                'ajaxLookupEmployments',
                'Die Funktion ' + endpoint + ' war leider nicht erfolgreich'
            );
        });
}

// ----------------------  ajax_lookup_access_certificate_valid_to --------------------------------------------------
export function ajax_lookup_access_certificate_valid_to() {

    $.post('/access_certificates/ajax_lookup_valid_to',
        {
            valid_from:    $('#access_certificate_valid_from').val() })
        .fail(function() {
            console.log('ajax_lookup_access_certificate_valid_to', 'Die Funktion /access_certificates/ajax_lookup_valid_to war leider nicht erfolgreich');
        });
}


export function ajax_get_access_certificate_filename() {

    $.post('/access_certificates/ajax_get_certificate_filename',
        {
            valid_from:    $('#access_certificate_valid_from').val(),
            valid_to:      $('#access_certificate_valid_to').val(),
            device_name:   $('#access_certificate_device_name').val()})
        .fail(function() {
            console.log('ajax_get_access_certificate_filename', 'Die Funktion /access_certificates/ajax_get_certificate_filename war leider nicht erfolgreich');
        });
}



export function docu_deactivator(object, docu_id, deactivation_value) {
    docu_elem='#'+object+'_'+docu_id
    deactivation_confirm_elem='#deactivation_confirm_'+docu_id
    //alert(docu_elem+' '+deactivation_confirm_elem+' '+$(docu_elem).is(":checked")+' '+(deactivation_value));
    if ($(docu_elem).is(":checked") == deactivation_value) {
        $(deactivation_confirm_elem).show();
    }
    else {
        $(deactivation_confirm_elem).hide();
    }
}


export function format_ajax_compliant(element) {
    v=$(element).val();
    v=replaceAll(new String(v), ";", ".");
    v=replaceAll(new String(v), "?", "-");
    v=replaceAll(new String(v), "&", "+");
    v=encodeURI(v);
    //$(element).val(v);
    return v;
}



// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
export function encodeRFC5987ValueChars(str) {
    return encodeURIComponent(str).
        // Beachte, dass obwohl RFC3986 "!" reserviert, es nicht kodiert
        // werden muss, weil RFC5987 es nicht reserviert.
        replace(/['()]/g, escape). // i.e., %27 %28 %29
        replace(/\*/g, '%2A').
        // Die folgenden Zeichen müssen nicht nach RFC5987 kodiert werden,
        // daher können wir bessere Lesbarkeit übers Netzwerk sicherstellen:
        // |`^
        replace(/%(?:7C|60|5E)/g, unescape);
}


// https://stackoverflow.com/questions/11025594/jquery-serialize-converts-all-spaces-to-plus
// $("#formToSerialize").serializeAndEncode();
// encodeURIComponent
$.fn.serializeAndEncode = function() {
    return $.map(this.serializeArray(), function(val) {
        return [val.name, encodeURIComponent(val.value)].join('=');
    }).join('&');
};



export function is_visible(e) {
    return ($(e).is(':visible'))
}


export function set_all_fieldset_inner_to(v) {
    var list = document.getElementsByClassName("fieldset_inner");
    for (var i = 0; i < list.length; i++) {
        if (v=='hidden')
            $(list[i]).slideUp();
        else
            $(list[i]).slideDown();
    }
}

export function ElementHide(e) {
    $('#'.e).hide()
}

export function ElementShow(e) {
    $('#'.e).show()
}

export function InnerHTML(e, html) {
    $('#'.e).html(html)
}


export function escapeRegExp(string) {
    return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}

export function replaceAll(str, find, replace) {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}


export function paint_fieldsets(status, exclude_class) {

    eleFieldsets = document.forms[0].getElementsByTagName("fieldset");
    for (var intCounter = 0; intCounter < eleFieldsets.length; intCounter++)
    {
        if (!exclude_class || (exclude_class && eleFieldsets[intCounter].className != exclude_class) && status!='')
            eleFieldsets[intCounter].className = 'fieldset_'+status;
    }

}

export function Left(str, n){
    if (n <= 0)
        return "";
    else if (n > String(str).length)
        return str;
    else
        return String(str).substring(0,n);
}

export function Right(str, n){
    if (n <= 0)
        return "";
    else if (n > String(str).length)
        return str;
    else {
        var iLen = String(str).length;
        return String(str).substring(iLen, iLen - n);
    }
}

export function format_comma(the_field, direction) {
    // changes ',' to '.'
    // direction: "todb": ','->'.'  vs. "fromdb": '.'->','

    //if (direction == 'fromdb') {
    //	f_comma = '.';
    //	t_comma = ',';
    //} else {
    // use always , to . otherwise non-edited values in textfields with , won't get converted to . and the fraction gets lost on saving the record
    //var f_comma=',';
    //var t_comma='.';
    //}
    var f_comma=',';
    var t_comma='.';
    var f=$(the_field).val();
    if (f) {
        $(the_field).val(f.replace(f_comma, t_comma));
    }
}

(function ($) {
    // c:260205 gpt5.2gw
    /**
     * Normalize & format numeric input safely
     *
     * @param {HTMLElement|jQuery} field
     * @param {Object} options
     *   integerOnly : Boolean (default false)
     *   precision   : Number|null (e.g. 2)
     *   format      : 'raw' | 'comma' (default 'raw')
     *
     *   normalize_number_input('#record_stunden_uebertrag', {
     *   integerOnly: true
     * });
     *
     * normalize_number_input('#record_kontingent_fb_regel', {
     *   precision: 2
     * });
     *
     */
    window.normalize_number_input_light = function (field) {
        var $field = $(field);
        var val = $field.val();

        if (!val) return;

        // allow typing ".5" or ",5"
        if (val === '.' || val === ',') return;

        val = val.replace(',', '.');
        val = val.replace(/[^0-9.\-]/g, '');
        val = val.replace(/(?!^)-/g, '');

        // only one decimal point
        var parts = val.split('.');
        if (parts.length > 2) {
            val = parts.shift() + '.' + parts.join('');
        }

        $field.val(val);
    };

    window.normalize_number_input_final = function (field, options) {
        options = options || {};

        var integerOnly = options.integerOnly === true;
        var precision   = typeof options.precision === 'number' ? options.precision : null;
        var format      = options.format || 'raw';

        var $field = $(field);
        var val = $field.val();

        if (!val) return;

        // leading "." or "," → "0.x"
        if (val[0] === '.' || val[0] === ',') {
            val = '0' + val;
        }

        val = val.replace(',', '.');

        var num = parseFloat(val);
        if (isNaN(num)) {
            $field.val('');
            return;
        }

        if (integerOnly) {
            num = Math.round(num);
        } else if (precision !== null) {
            num = num.toFixed(precision);
        }

        var out = num.toString();
        if (format === 'comma') {
            out = out.replace('.', ',');
        }

        $field.val(out);
    };

})($);


(function ($) {

    // c:260205 gpt5.2gw
    // === GENERAL TAKEOVER FUNCTION ===

    /**
     * expects these form_fields/DOM elements:
     *
     * content_tag(:span, '2 Tage übernehmen', id: 'uebertrag_vorjahr_carryover', class: 'clickable_text small')
     * hidden_field_tag :uebertrag_vorjahr_val, 2
     * text_field :record, :uebertrag_vorjahr
     *
     */

    window.apply_carryover_value = function (baseId) {
        var value = $('#' + baseId + '_val').val();
        var $target = $('#record_' + baseId);

        if ($target.length === 0) return;

        $target.val(value).trigger('change');
    };

    function bindTakeoverHandlers() {
        $('[id$="_carryover"]').on('click', function () {
            var carryoverId = this.id; // e.g. kontingent_fb_uebertrag_carryover
            var baseId = carryoverId.replace('_carryover', '');

            apply_carryover_value(baseId);
        });
    }

    // Rails 4.2 + Turbolinks
    $(document).on('ready turbolinks:load', function () {
        bindTakeoverHandlers();
    });

})($);


export function SetPageToBusy() {
    dimmed_element('body', 'show');
    //$('#dim').fadeIn(300);
    //$('#spinnerbox').show('fast');
    return true;
}

export function SetPageToIdle() {
    dimmed_element('body', 'hide');
    //$('#spinnerbox').hide('fast');
    //$('#dim').fadeOut(200);
    return true;
}

// 260721nrai: r4 merge — Administrative Aggregation-Storno (AZ list / journal).
// Expects data-url, data-az-id, data-aggregation-code on the link.
export function azStornoReverse(el) {
    var $el = $(el);
    var url = $el.attr('data-url');
    var azId = $el.attr('data-az-id');
    var code = $el.attr('data-aggregation-code');
    var scope = $el.attr('data-scope') || 'employee';
    if (!url || !azId) { return false; }

    var msg = window.prompt('Storno dokumentieren — verpflichtende Begründung für das Audit-Protokoll:', '');
    if (msg === null) { return false; }
    msg = String(msg).replace(/^\s+|\s+$/g, '');
    if (!msg) {
        alert('Storno ohne Begründung nicht möglich.');
        return false;
    }

    SetPageToBusy();
    var token = $('meta[name="csrf-token"]').attr('content');
    $.ajax({
        type: 'POST',
        url: url,
        data: {
            authenticity_token: token,
            az_id: azId,
            aggregation_code: code,
            reversed_commit: msg,
            scope: scope
        },
        dataType: 'script'
    }).fail(function (xhr) {
        SetPageToIdle();
        var detail = (xhr && xhr.status) ? ('HTTP ' + xhr.status) : 'unbekannt';
        alert('Storno fehlgeschlagen (' + detail + ').');
    });
    return false;
}

export function dim_the_form() {
    // used in time_record.rb to render the edit_link_tag with dimmed 'the_form'
    dimmed_element('#the_form', 'hide');
}

// 260511nrai: dim/spinner stay on body (AJAX must not remove #dim); fixed rect from getBoundingClientRect + scroll/resize sync
let dimmedElementScrollHandler = null;

function teardownDimmedElementOverlay() {
    $(window).off("resize.dimmed_element");
    if (dimmedElementScrollHandler) {
        document.removeEventListener("scroll", dimmedElementScrollHandler, true);
        dimmedElementScrollHandler = null;
    }
}

function appendDimSpinnerToBody($dim, $spinnerbox) {
    $dim.detach().appendTo($("body"));
    $spinnerbox.detach().appendTo($("body"));
}

function syncDimOverlayToTarget($target, $dim, $spinnerbox) {
    const el = $target[0];
    if (!el || !document.documentElement.contains(el)) {
        return;
    }
    const rect = el.getBoundingClientRect();
    $dim.css({
        position: "fixed",
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
        boxSizing: "border-box",
        display: "block",
        zIndex: 5000,
    });
    positionSpinnerInVisiblePortion($target, $spinnerbox);
}

function positionSpinnerInVisiblePortion($target, $spinnerbox) {
    const el = $target[0];
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const visibleTop = Math.max(0, rect.top);
    const visibleBottom = Math.min(vh, rect.bottom);
    const visibleLeft = Math.max(0, rect.left);
    const visibleRight = Math.min(vw, rect.right);
    const visibleHeight = visibleBottom - visibleTop;
    const visibleWidth = visibleRight - visibleLeft;
    const outerH = $spinnerbox.outerHeight() || 100;
    const outerW = $spinnerbox.outerWidth() || 100;
    let spinnerTop;
    let spinnerLeft;
    if (visibleHeight <= 0 || visibleWidth <= 0) {
        spinnerTop = vh / 2 - outerH / 2;
        spinnerLeft = vw / 2 - outerW / 2;
    } else {
        spinnerTop = visibleTop + visibleHeight / 2 - outerH / 2;
        spinnerLeft = visibleLeft + visibleWidth / 2 - outerW / 2;
    }
    $spinnerbox.css({
        position: "fixed",
        top: spinnerTop,
        left: spinnerLeft,
        margin: 0,
        transform: "none",
        zIndex: 20001,
    });
}

export function dimmed_element(element, action) {
    const $dim = $("#dim");
    const $spinnerbox = $("#spinnerbox");

    if (action === "show") {
        if (element === "body") {
            teardownDimmedElementOverlay();
            $dim.removeData("dimmedTarget");
            appendDimSpinnerToBody($dim, $spinnerbox);
            $dim.removeAttr("style");
            $spinnerbox.removeAttr("style");

            // For the 'body', set overlay to cover the full viewport
            $dim.css({
                top: 0,
                left: 0,
                height: "100vh", // Full viewport height
                width: "100vw", // Full viewport width
                display: "block",
            }).fadeIn(300);

            // Center the spinner within the viewport
            const spinnerTop =
                $(window).scrollTop() +
                $(window).height() / 2 -
                $spinnerbox.outerHeight() / 2;
            const spinnerLeft =
                $(window).scrollLeft() +
                $(window).width() / 2 -
                $spinnerbox.outerWidth() / 2;

            $spinnerbox.css({
                top: spinnerTop,
                left: spinnerLeft,
                display: "block",
            }).show("fast");
        } else {
            const $target = $(element);
            if (!$target.length) return;

            teardownDimmedElementOverlay();

            appendDimSpinnerToBody($dim, $spinnerbox);
            $dim.removeAttr("style");
            $spinnerbox.removeAttr("style");

            $dim.data("dimmedTarget", $target);

            const repaint = () => {
                syncDimOverlayToTarget($target, $dim, $spinnerbox);
            };
            repaint();
            dimmedElementScrollHandler = repaint;
            document.addEventListener("scroll", dimmedElementScrollHandler, true);
            $(window).on("resize.dimmed_element", repaint);

            $dim.fadeIn(300);
            $spinnerbox.css({ display: "block" }).show("fast");
        }
    } else if (action === "hide") {
        const $hidTarget = $dim.data("dimmedTarget");
        teardownDimmedElementOverlay();

        $spinnerbox.hide("fast", function () {
            $spinnerbox.removeAttr("style").hide();
        });

        if ($hidTarget && $hidTarget.length) {
            $dim.fadeOut(200, function () {
                appendDimSpinnerToBody($dim, $spinnerbox);
                $dim.removeAttr("style").hide();
                $dim.removeData("dimmedTarget");
            });
        } else {
            $dim.fadeOut(200, function () {
                $dim.removeAttr("style").hide();
            });
        }
    }
}


function dimmed_element_____V1______(element, action) {
    const $dim = $("#dim");
    const $spinnerbox = $("#spinnerbox");

    if (action === "show") {
        if (element === "body") {
            // If dimming the entire body, set full viewport dimensions
            $dim.css({
                top: 0,
                left: 0,
                height: "100vh", // Full viewport height
                width: "100vw"  // Full viewport width
            });

            // Center the spinner within the viewport, adjusted for scroll
            const spinnerTop = $(window).scrollTop() + $(window).height() / 2 - $spinnerbox.outerHeight() / 2;
            const spinnerLeft = $(window).scrollLeft() + $(window).width() / 2 - $spinnerbox.outerWidth() / 2;

            $spinnerbox.css({
                top: spinnerTop,
                left: spinnerLeft
            });
        } else {
            // If dimming a specific element
            const offset = $(element).offset();
            const height = $(element).outerHeight();
            const width = $(element).outerWidth();

            // Position the dim overlay over the target element
            $dim.css({
                top: offset.top - $(window).scrollTop(),
                left: offset.left - $(window).scrollLeft(),
                height: height,
                width: width
            });

            // Center the spinner within the target element, adjusted for scroll
            const spinnerTop = offset.top - $(window).scrollTop() + height / 2 - $spinnerbox.outerHeight() / 2;
            const spinnerLeft = offset.left - $(window).scrollLeft() + width / 2 - $spinnerbox.outerWidth() / 2;

            $spinnerbox.css({
                top: spinnerTop,
                left: spinnerLeft
            });
        }

        $dim.fadeIn(300);       // Fade in the dim overlay
        $spinnerbox.show("fast"); // Show the spinner quickly

    } else if (action === "hide") {
        $spinnerbox.hide("fast"); // Hide the spinner quickly
        $dim.fadeOut(200);       // Fade out the dim overlay
    }
}

export function auto_hide(identifier, delay, fadeoutrate) {
    $(identifier).delay(delay || 7000).fadeOut(fadeoutrate);
}

export function AutoHideFlashZone(delay) {
    $('#flash_notice').delay(delay || 7000).fadeOut('slow');
    $('#flash_error').delay(delay || 7000).fadeOut('slow');
}


// ------------ Tasks Overlap Type -------------------------------
export function reset_overlap_images() {
    $('#overlap_type_img_0').attr('class', 'overlap_type_img_00');
    $('#overlap_type_img_1').attr('class', 'overlap_type_img_10');
    $('#overlap_type_img_2').attr('class', 'overlap_type_img_20');
}

export function focus_overlap_image(img) {
    $('#overlap_type_img_'+img).attr('class', 'overlap_type_img_'+img+'1');
}

export function reset_overlap_radio() {
    $('#record_overlap_type_0').prop('checked', false);
    $('#record_overlap_type_1').prop('checked', false);
    $('#record_overlap_type_2').prop('checked', false);
    document.getElementsByName('record[overlap_type]').value=null ;
}

export function paint_overlap_region() {
    if ($('#record_multiple_time_windows').prop('checked')) {
        $('#overlap_type_region').show(400);
        reset_overlap_images();
        for (i=0; i<3; i++) {
            if ($('#record_overlap_type_'+i).prop('checked'))
                focus_overlap_image(i);
        }

    } else {
        $('#overlap_type_region').hide(400);
        reset_overlap_radio();
        reset_overlap_images();
    }
}

